import { render } from "./roll-call.vue?vue&type=template&id=758256d4&scoped=true"
import script from "./roll-call.vue?vue&type=script&lang=js"
export * from "./roll-call.vue?vue&type=script&lang=js"

import "./roll-call.vue?vue&type=style&index=0&id=758256d4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-758256d4"]])

export default __exports__